import EquipmentTable from './EquipmentTable';

export default EquipmentTable;
